@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.service

actual class PendingUploadService actual constructor() {
    actual fun retryPendingUploads(
        callback: PendingUploadCallback
    ) {
        //for non-mobile platforms no need to do anything here
    }

    actual fun reattachOngoingUploads(callback: ChunkUploadCallback) {
        //for non-mobile platforms the ChunkUploadService liveCallbacks map handles this directly
    }

    actual fun cancel() {
        //for non-mobile platforms no need to do anything here
    }
}
